import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import {
  RecordCount,
  recordsCountTextGetterFactory,
  TextGetters,
} from "@app/component/RecordList/index";

import styles from "./MultiPinInformation.module.scss";

interface Props {
  multiPinAddress?: string;
  recordsCount: number;
  showAddress?: boolean;
}

const MultiPinInformation: React.FC<Props> = ({
  multiPinAddress,
  recordsCount,
  showAddress = true,
}) => {
  const intl = useIntl();

  const textGetters: TextGetters = useMemo(
    () => ({
      countTextGetter: recordsCountTextGetterFactory(intl),
    }),
    [intl]
  );

  return (
    <div className={styles.container}>
      <RecordCount count={textGetters.countTextGetter(recordsCount)} />
      {showAddress && multiPinAddress && <div className={styles.address}>{multiPinAddress}</div>}
    </div>
  );
};

export default MultiPinInformation;
